import { Pipe, PipeTransform } from '@angular/core';
import { FormArray } from '@angular/forms';

@Pipe({ name: 'excludeDuplicates' })
export class ExcludeDuplicatesPipe implements PipeTransform {
  transform(items: any[], excludeItems: FormArray): any[] {
   
    if (!items)
      return [];

    if (excludeItems.length <= 1) {
      return items;
    }

    // parse controls into string array
    let excludeStrings = excludeItems.controls.map(x => {
      return x.value["name"].toLowerCase();
    });

    // now exclude those from the list
    items = items.filter(it => {
      return !excludeStrings.includes(it.toLowerCase());
    });
     
    return items;
  }
}
